export const getRolesTypes = () => {
    return [
        {id: '29827f3b28404490afb0c77766a3279a', name: 'Trainer'},
        {id: 'dfa856ce88104968a7010b9a5e31fb58', name: 'Administrator'},
        {id: 'c35851102cab49ff9d31e71c4a82b4e1', name: 'SuperAdmin'},
        {id: '55f20c232859401da884b95bbd6535a4', name: 'Agent'},
        {id: '115f18b805a14946824cb1fcfcf2e72d', name: 'Supervisor'}
    ]
}